module.exports = __webpack_public_path__ + "img/no-result.070dd9ba.png";